iScreenWizard.controller('AccountinformatieController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Opleidingsgroep, Testtype, Testsoort, RapporttemplateCompetentieprofieltype, Rapporttemplate, Test, Testset, Testotheek, WizardFeedbackRapporttype, userService) {

    $scope.rapporttemplatecompetentieprofieltypes = [];
    $scope.opleidingsgroepen = [];
    $scope.testtypes = [];
    $scope.testsoorten = [];

    $scope.rapporttemplates = [];

    $scope.testotheken = [];

    $scope.user = userService.model;

    $scope.wizardfeedbackrapporttypes = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        RapporttemplateCompetentieprofieltype.all().then(function (rapporttemplatecompetentieprofieltypes) {
            $scope.rapporttemplatecompetentieprofieltypes = rapporttemplatecompetentieprofieltypes;
        });
        Opleidingsgroep.all().then(function (opleidingsgroepen) {
            $scope.opleidingsgroepen = opleidingsgroepen;
        });
        Testtype.all().then(function (testtypes) {
            $scope.testtypes = testtypes;
        });
        Testsoort.all().then(function (testsoorten) {
            $scope.testsoorten = testsoorten;
        });
        Rapporttemplate.all({alleen_met_competentieprofiel_type: 1, klantorganisatie_id: $scope.user.klantorganisatie_id}).then(function (rapporttemplates) {
            angular.forEach(rapporttemplates, function (rapporttemplate) {
                if (rapporttemplate.informatiebestand_url.length > 0) {
                    rapporttemplate.informatiebestand_url = baseUrl + rapporttemplate.informatiebestand_url + '?jwt=' + userService.getToken();
                }
                if (rapporttemplate.voorbeeldbestand_url.length > 0) {
                    rapporttemplate.voorbeeldbestand_url = baseUrl + rapporttemplate.voorbeeldbestand_url + '?jwt=' + userService.getToken();
                }
            });
            $scope.rapporttemplates = rapporttemplates;
        });
        Testotheek.all().then(function (testotheken) {
            angular.forEach(testotheken, function (testotheek) {
                if (testotheek.informatiebestand_url.length > 0) {
                    testotheek.informatiebestand_url = baseUrl + testotheek.informatiebestand_url + '?jwt=' + userService.getToken();
                }
                if (testotheek.voorbeeldbestand_url.length > 0) {
                    testotheek.voorbeeldbestand_url = baseUrl + testotheek.voorbeeldbestand_url + '?jwt=' + userService.getToken();
                }
            });
            $scope.testotheken = testotheken;
        });
        WizardFeedbackRapporttype.all().then(function (wizardfeedbackrapporttypes) {
            $scope.wizardfeedbackrapporttypes = wizardfeedbackrapporttypes;
        });
    };

    $scope.compareNumber = function(actual, expected) {
        return angular.equals(''+actual, ''+expected)
    };

});